var _defs, _title, _polygon, _polygon2, _polygon3, _path, _path2, _rect, _polygon4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _polygon5, _polygon6, _polygon7, _polygon8, _path209, _polygon9, _polygon10, _polygon11, _path210, _path211, _polygon12, _path212, _path213, _ellipse, _ellipse2, _path214, _ellipse3, _ellipse4, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _g, _path261, _ellipse5, _path262, _path263, _path264, _ellipse6, _path265, _path266, _path267;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBanKharColored = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254.48,
    height: 449.63,
    viewBox: "0 0 254.48 449.63",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 893.84,
    y1: 362.23,
    x2: 893.84,
    y2: 293.93,
    gradientTransform: "matrix(-1, 0, 0, 1, 1052.54, 71.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b72026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911c23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 955.36,
    y1: 362.23,
    x2: 955.36,
    y2: 293.93,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    transform: "translate(0 -0.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.38,279.79c11.68,0,13.67,5.94,13.68,13.27s-2,13.28-13.66,13.29-21.14-5.93-21.15-13.27S55.71,279.79,67.38,279.79Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    transform: "translate(0 -0.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.17,
    y: 261.44,
    width: 49.7,
    height: 63.24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 603.27,
    y1: 2050.93,
    x2: 603.27,
    y2: 2058.88,
    gradientTransform: "matrix(0, 1, 1, 0, -1963, -340.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#221f1f",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#221f1f",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221f1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 611.18,
    y1: 2050.93,
    x2: 611.18,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 619.08,
    y1: 2050.93,
    x2: 619.08,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 626.99,
    y1: 2050.93,
    x2: 626.99,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 634.89,
    y1: 2050.93,
    x2: 634.89,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 642.8,
    y1: 2050.93,
    x2: 642.8,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 650.7,
    y1: 2050.93,
    x2: 650.7,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 658.61,
    y1: 2050.93,
    x2: 658.61,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 666.51,
    y1: 2050.93,
    x2: 666.51,
    y2: 2058.88,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 607.22,
    y1: 2045.96,
    x2: 607.22,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 615.13,
    y1: 2045.96,
    x2: 615.13,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 623.03,
    y1: 2045.96,
    x2: 623.03,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 630.94,
    y1: 2045.96,
    x2: 630.94,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 638.84,
    y1: 2045.96,
    x2: 638.84,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 646.75,
    y1: 2045.96,
    x2: 646.75,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 654.65,
    y1: 2045.96,
    x2: 654.65,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 662.56,
    y1: 2045.96,
    x2: 662.56,
    y2: 2053.91,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 603.27,
    y1: 2040.99,
    x2: 603.27,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 611.18,
    y1: 2040.99,
    x2: 611.18,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 619.08,
    y1: 2040.99,
    x2: 619.08,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 626.99,
    y1: 2040.99,
    x2: 626.99,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 634.89,
    y1: 2040.99,
    x2: 634.89,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 642.8,
    y1: 2040.99,
    x2: 642.8,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 650.7,
    y1: 2040.99,
    x2: 650.7,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 658.61,
    y1: 2040.99,
    x2: 658.61,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 666.51,
    y1: 2040.99,
    x2: 666.51,
    y2: 2048.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 607.22,
    y1: 2036.02,
    x2: 607.22,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 615.13,
    y1: 2036.02,
    x2: 615.13,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 623.03,
    y1: 2036.02,
    x2: 623.03,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 630.94,
    y1: 2036.02,
    x2: 630.94,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 638.84,
    y1: 2036.02,
    x2: 638.84,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 646.75,
    y1: 2036.02,
    x2: 646.75,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 654.65,
    y1: 2036.02,
    x2: 654.65,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 662.56,
    y1: 2036.02,
    x2: 662.56,
    y2: 2043.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 603.27,
    y1: 2031.05,
    x2: 603.27,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 611.18,
    y1: 2031.05,
    x2: 611.18,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 619.08,
    y1: 2031.05,
    x2: 619.08,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 626.99,
    y1: 2031.05,
    x2: 626.99,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 634.89,
    y1: 2031.05,
    x2: 634.89,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 642.8,
    y1: 2031.05,
    x2: 642.8,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 650.7,
    y1: 2031.05,
    x2: 650.7,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 658.61,
    y1: 2031.05,
    x2: 658.61,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 666.51,
    y1: 2031.05,
    x2: 666.51,
    y2: 2039,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 607.22,
    y1: 2026.08,
    x2: 607.22,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 615.13,
    y1: 2026.08,
    x2: 615.13,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 623.03,
    y1: 2026.08,
    x2: 623.03,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 630.94,
    y1: 2026.08,
    x2: 630.94,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 638.84,
    y1: 2026.08,
    x2: 638.84,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 646.75,
    y1: 2026.08,
    x2: 646.75,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 654.65,
    y1: 2026.08,
    x2: 654.65,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 662.56,
    y1: 2026.08,
    x2: 662.56,
    y2: 2034.03,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 603.27,
    y1: 2021.11,
    x2: 603.27,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 611.18,
    y1: 2021.11,
    x2: 611.18,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 619.08,
    y1: 2021.11,
    x2: 619.08,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 626.99,
    y1: 2021.11,
    x2: 626.99,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 634.89,
    y1: 2021.11,
    x2: 634.89,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 642.8,
    y1: 2021.11,
    x2: 642.8,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 650.7,
    y1: 2021.11,
    x2: 650.7,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 658.61,
    y1: 2021.11,
    x2: 658.61,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 666.51,
    y1: 2021.11,
    x2: 666.51,
    y2: 2029.06,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 607.22,
    y1: 2016.14,
    x2: 607.22,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 615.13,
    y1: 2016.14,
    x2: 615.13,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 623.03,
    y1: 2016.14,
    x2: 623.03,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 630.94,
    y1: 2016.14,
    x2: 630.94,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 638.84,
    y1: 2016.14,
    x2: 638.84,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 646.75,
    y1: 2016.14,
    x2: 646.75,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 654.65,
    y1: 2016.14,
    x2: 654.65,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 662.56,
    y1: 2016.14,
    x2: 662.56,
    y2: 2024.09,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 603.27,
    y1: 2011.17,
    x2: 603.27,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 611.18,
    y1: 2011.17,
    x2: 611.18,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 619.08,
    y1: 2011.17,
    x2: 619.08,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 626.99,
    y1: 2011.17,
    x2: 626.99,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 634.89,
    y1: 2011.17,
    x2: 634.89,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 642.8,
    y1: 2011.17,
    x2: 642.8,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 650.7,
    y1: 2011.17,
    x2: 650.7,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 658.61,
    y1: 2011.17,
    x2: 658.61,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 666.51,
    y1: 2011.17,
    x2: 666.51,
    y2: 2019.12,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 607.22,
    y1: 2006.2,
    x2: 607.22,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 615.13,
    y1: 2006.2,
    x2: 615.13,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 623.03,
    y1: 2006.2,
    x2: 623.03,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 630.94,
    y1: 2006.2,
    x2: 630.94,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 638.84,
    y1: 2006.2,
    x2: 638.84,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 646.75,
    y1: 2006.2,
    x2: 646.75,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 654.65,
    y1: 2006.2,
    x2: 654.65,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 662.56,
    y1: 2006.2,
    x2: 662.56,
    y2: 2014.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 603.27,
    y1: 2001.23,
    x2: 603.27,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 611.18,
    y1: 2001.23,
    x2: 611.18,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 619.08,
    y1: 2001.23,
    x2: 619.08,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 626.99,
    y1: 2001.23,
    x2: 626.99,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 634.89,
    y1: 2001.23,
    x2: 634.89,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 642.8,
    y1: 2001.23,
    x2: 642.8,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 650.7,
    y1: 2001.23,
    x2: 650.7,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 658.61,
    y1: 2001.23,
    x2: 658.61,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 666.51,
    y1: 2001.23,
    x2: 666.51,
    y2: 2009.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 607.22,
    y1: 1996.26,
    x2: 607.22,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 615.13,
    y1: 1996.26,
    x2: 615.13,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 623.03,
    y1: 1996.26,
    x2: 623.03,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 630.94,
    y1: 1996.26,
    x2: 630.94,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 638.84,
    y1: 1996.26,
    x2: 638.84,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 646.75,
    y1: 1996.26,
    x2: 646.75,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 654.65,
    y1: 1996.26,
    x2: 654.65,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 662.56,
    y1: 1996.26,
    x2: 662.56,
    y2: 2004.21,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc",
    transform: "translate(0 -0.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.38,306.28c-11.68,0-13.67-5.94-13.68-13.27s2-13.28,13.66-13.29,21.14,5.93,21.15,13.27S199.05,306.27,187.38,306.28Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd",
    transform: "translate(0 -0.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.89,
    y: 261.38,
    width: 49.7,
    height: 63.24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 2710.77,
    y1: 702.12,
    x2: 2710.77,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 2718.67,
    y1: 702.12,
    x2: 2718.67,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: 2726.58,
    y1: 702.12,
    x2: 2726.58,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: 2734.48,
    y1: 702.12,
    x2: 2734.48,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 2742.39,
    y1: 702.12,
    x2: 2742.39,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: 2750.3,
    y1: 702.12,
    x2: 2750.3,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: 2758.2,
    y1: 702.12,
    x2: 2758.2,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: 2766.11,
    y1: 702.12,
    x2: 2766.11,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: 2774.01,
    y1: 702.12,
    x2: 2774.01,
    y2: 710.07,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: 2714.72,
    y1: 697.15,
    x2: 2714.72,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    x1: 2722.63,
    y1: 697.15,
    x2: 2722.63,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: 2730.53,
    y1: 697.15,
    x2: 2730.53,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dq",
    x1: 2738.44,
    y1: 697.15,
    x2: 2738.44,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 2746.34,
    y1: 697.15,
    x2: 2746.34,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 2754.25,
    y1: 697.15,
    x2: 2754.25,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dt",
    x1: 2762.15,
    y1: 697.15,
    x2: 2762.15,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "du",
    x1: 2770.06,
    y1: 697.15,
    x2: 2770.06,
    y2: 705.1,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dv",
    x1: 2710.77,
    y1: 692.18,
    x2: 2710.77,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dw",
    x1: 2718.67,
    y1: 692.18,
    x2: 2718.67,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dx",
    x1: 2726.58,
    y1: 692.18,
    x2: 2726.58,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dy",
    x1: 2734.48,
    y1: 692.18,
    x2: 2734.48,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dz",
    x1: 2742.39,
    y1: 692.18,
    x2: 2742.39,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea",
    x1: 2750.3,
    y1: 692.18,
    x2: 2750.3,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb",
    x1: 2758.2,
    y1: 692.18,
    x2: 2758.2,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec",
    x1: 2766.11,
    y1: 692.18,
    x2: 2766.11,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed",
    x1: 2774.01,
    y1: 692.18,
    x2: 2774.01,
    y2: 700.13,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee",
    x1: 2714.72,
    y1: 687.21,
    x2: 2714.72,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef",
    x1: 2722.63,
    y1: 687.21,
    x2: 2722.63,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eg",
    x1: 2730.53,
    y1: 687.21,
    x2: 2730.53,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eh",
    x1: 2738.44,
    y1: 687.21,
    x2: 2738.44,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ei",
    x1: 2746.34,
    y1: 687.21,
    x2: 2746.34,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ej",
    x1: 2754.25,
    y1: 687.21,
    x2: 2754.25,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ek",
    x1: 2762.15,
    y1: 687.21,
    x2: 2762.15,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "el",
    x1: 2770.06,
    y1: 687.21,
    x2: 2770.06,
    y2: 695.16,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "em",
    x1: 2710.77,
    y1: 682.24,
    x2: 2710.77,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en",
    x1: 2718.67,
    y1: 682.24,
    x2: 2718.67,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eo",
    x1: 2726.58,
    y1: 682.24,
    x2: 2726.58,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ep",
    x1: 2734.48,
    y1: 682.24,
    x2: 2734.48,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eq",
    x1: 2742.39,
    y1: 682.24,
    x2: 2742.39,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "er",
    x1: 2750.3,
    y1: 682.24,
    x2: 2750.3,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es",
    x1: 2758.2,
    y1: 682.24,
    x2: 2758.2,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "et",
    x1: 2766.11,
    y1: 682.24,
    x2: 2766.11,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eu",
    x1: 2774.01,
    y1: 682.24,
    x2: 2774.01,
    y2: 690.19,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ev",
    x1: 2714.72,
    y1: 677.27,
    x2: 2714.72,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ew",
    x1: 2722.63,
    y1: 677.27,
    x2: 2722.63,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ex",
    x1: 2730.53,
    y1: 677.27,
    x2: 2730.53,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ey",
    x1: 2738.44,
    y1: 677.27,
    x2: 2738.44,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ez",
    x1: 2746.34,
    y1: 677.27,
    x2: 2746.34,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa",
    x1: 2754.25,
    y1: 677.27,
    x2: 2754.25,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb",
    x1: 2762.15,
    y1: 677.27,
    x2: 2762.15,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 2770.06,
    y1: 677.27,
    x2: 2770.06,
    y2: 685.22,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd",
    x1: 2710.77,
    y1: 672.3,
    x2: 2710.77,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe",
    x1: 2718.67,
    y1: 672.3,
    x2: 2718.67,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff",
    x1: 2726.58,
    y1: 672.3,
    x2: 2726.58,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fg",
    x1: 2734.48,
    y1: 672.3,
    x2: 2734.48,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fh",
    x1: 2742.39,
    y1: 672.3,
    x2: 2742.39,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fi",
    x1: 2750.3,
    y1: 672.3,
    x2: 2750.3,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj",
    x1: 2758.2,
    y1: 672.3,
    x2: 2758.2,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fk",
    x1: 2766.11,
    y1: 672.3,
    x2: 2766.11,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fl",
    x1: 2774.01,
    y1: 672.3,
    x2: 2774.01,
    y2: 680.25,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm",
    x1: 2714.72,
    y1: 667.33,
    x2: 2714.72,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fn",
    x1: 2722.63,
    y1: 667.33,
    x2: 2722.63,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fo",
    x1: 2730.53,
    y1: 667.33,
    x2: 2730.53,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp",
    x1: 2738.44,
    y1: 667.33,
    x2: 2738.44,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fq",
    x1: 2746.34,
    y1: 667.33,
    x2: 2746.34,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fr",
    x1: 2754.25,
    y1: 667.33,
    x2: 2754.25,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fs",
    x1: 2762.15,
    y1: 667.33,
    x2: 2762.15,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ft",
    x1: 2770.06,
    y1: 667.33,
    x2: 2770.06,
    y2: 675.28,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu",
    x1: 2710.77,
    y1: 662.36,
    x2: 2710.77,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv",
    x1: 2718.67,
    y1: 662.36,
    x2: 2718.67,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fw",
    x1: 2726.58,
    y1: 662.36,
    x2: 2726.58,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fx",
    x1: 2734.48,
    y1: 662.36,
    x2: 2734.48,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fy",
    x1: 2742.39,
    y1: 662.36,
    x2: 2742.39,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fz",
    x1: 2750.3,
    y1: 662.36,
    x2: 2750.3,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ga",
    x1: 2758.2,
    y1: 662.36,
    x2: 2758.2,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gb",
    x1: 2766.11,
    y1: 662.36,
    x2: 2766.11,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gc",
    x1: 2774.01,
    y1: 662.36,
    x2: 2774.01,
    y2: 670.31,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gd",
    x1: 2714.72,
    y1: 657.39,
    x2: 2714.72,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ge",
    x1: 2722.63,
    y1: 657.39,
    x2: 2722.63,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gf",
    x1: 2730.53,
    y1: 657.39,
    x2: 2730.53,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gg",
    x1: 2738.44,
    y1: 657.39,
    x2: 2738.44,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gh",
    x1: 2746.34,
    y1: 657.39,
    x2: 2746.34,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gi",
    x1: 2754.25,
    y1: 657.39,
    x2: 2754.25,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gj",
    x1: 2762.15,
    y1: 657.39,
    x2: 2762.15,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gk",
    x1: 2770.06,
    y1: 657.39,
    x2: 2770.06,
    y2: 665.34,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl",
    x1: 2710.77,
    y1: 652.42,
    x2: 2710.77,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gm",
    x1: 2718.67,
    y1: 652.42,
    x2: 2718.67,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gn",
    x1: 2726.58,
    y1: 652.42,
    x2: 2726.58,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go",
    x1: 2734.48,
    y1: 652.42,
    x2: 2734.48,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp",
    x1: 2742.39,
    y1: 652.42,
    x2: 2742.39,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gq",
    x1: 2750.3,
    y1: 652.42,
    x2: 2750.3,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr",
    x1: 2758.2,
    y1: 652.42,
    x2: 2758.2,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gs",
    x1: 2766.11,
    y1: 652.42,
    x2: 2766.11,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt",
    x1: 2774.01,
    y1: 652.42,
    x2: 2774.01,
    y2: 660.37,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gu",
    x1: 2714.72,
    y1: 647.45,
    x2: 2714.72,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gv",
    x1: 2722.63,
    y1: 647.45,
    x2: 2722.63,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gw",
    x1: 2730.53,
    y1: 647.45,
    x2: 2730.53,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gx",
    x1: 2738.44,
    y1: 647.45,
    x2: 2738.44,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gy",
    x1: 2746.34,
    y1: 647.45,
    x2: 2746.34,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gz",
    x1: 2754.25,
    y1: 647.45,
    x2: 2754.25,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ha",
    x1: 2762.15,
    y1: 647.45,
    x2: 2762.15,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hb",
    x1: 2770.06,
    y1: 647.45,
    x2: 2770.06,
    y2: 655.4,
    gradientTransform: "matrix(0, -1, -1, 0, 870.17, 3035)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "hc",
    x: 42.05,
    y: 3.48,
    width: 175.52,
    height: 220.58,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.48,81.21c.06-1.19.09-2.39.09-3.59,0-42.75-35.64-73.76-76.32-73.76S52.06,34,52.06,76.8c0,1.49.05,3,.14,4.46h-.14l.26,1.52a80.73,80.73,0,0,0,2.41,14.29L66,164c2.24,13.27,10.33,23.29,21.14,32.28a79.65,79.65,0,0,0,18.06,11.61,88,88,0,0,0,10.13,3.78h0a28.29,28.29,0,0,0,2.81.74c.94.22,1.85.39,2.71.5a51.29,51.29,0,0,0,15,.08,31.34,31.34,0,0,0,5.24-1,48.86,48.86,0,0,0,6.82-2.28h0c1.89-.73,3.44-1.39,4.29-1.78a79.7,79.7,0,0,0,18.06-11.61c10.81-9,18.91-19,21.14-32.28,4.65-27.59,8.42-55.24,13.07-82.84h0",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hd",
    x1: -194.25,
    y1: 762.21,
    x2: -194.25,
    y2: 760.93,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5017.25, 19059.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#231f20",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#231f20",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "he",
    x1: -195.48,
    y1: 762.38,
    x2: -195.48,
    y2: 761.1,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4906.1, 19044.1)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hf",
    x1: -195.21,
    y1: 762.38,
    x2: -195.21,
    y2: 761.1,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4930.9, 19044.1)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hg",
    x1: -194.94,
    y1: 762.38,
    x2: -194.94,
    y2: 761.1,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4954.84, 19044.1)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hh",
    x1: -194.67,
    y1: 762.38,
    x2: -194.67,
    y2: 761.1,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4979.63, 19044.1)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hi",
    x1: -194.39,
    y1: 762.38,
    x2: -194.39,
    y2: 761.1,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5004.43, 19044.1)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hj",
    x1: -195.35,
    y1: 762.56,
    x2: -195.35,
    y2: 761.28,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4918.07, 19027.87)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hk",
    x1: -195.08,
    y1: 762.56,
    x2: -195.08,
    y2: 761.28,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4942.87, 19027.87)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hl",
    x1: -194.8,
    y1: 762.56,
    x2: -194.8,
    y2: 761.28,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4967.66, 19027.87)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hm",
    x1: -194.53,
    y1: 762.56,
    x2: -194.53,
    y2: 761.28,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4992.46, 19027.87)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hn",
    x1: -194.25,
    y1: 762.56,
    x2: -194.25,
    y2: 761.28,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5017.25, 19027.87)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ho",
    x1: -195.48,
    y1: 762.73,
    x2: -195.48,
    y2: 761.46,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4906.1, 19012.49)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp",
    x1: -195.21,
    y1: 762.73,
    x2: -195.21,
    y2: 761.46,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4930.9, 19012.49)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hq",
    x1: -194.94,
    y1: 762.73,
    x2: -194.94,
    y2: 761.46,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4954.84, 19012.49)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr",
    x1: -194.67,
    y1: 762.73,
    x2: -194.67,
    y2: 761.46,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4979.63, 19012.49)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hs",
    x1: -194.39,
    y1: 762.73,
    x2: -194.39,
    y2: 761.46,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5004.43, 19012.49)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ht",
    x1: -195.35,
    y1: 762.9,
    x2: -195.35,
    y2: 761.63,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4918.07, 18997.12)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hu",
    x1: -195.08,
    y1: 762.9,
    x2: -195.08,
    y2: 761.63,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4942.87, 18997.12)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hv",
    x1: -194.8,
    y1: 762.9,
    x2: -194.8,
    y2: 761.63,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4967.66, 18997.12)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hw",
    x1: -194.53,
    y1: 762.9,
    x2: -194.53,
    y2: 761.63,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4992.46, 18997.12)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hx",
    x1: -194.25,
    y1: 762.9,
    x2: -194.25,
    y2: 761.63,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5017.25, 18997.12)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hy",
    x1: -195.48,
    y1: 763.07,
    x2: -195.48,
    y2: 761.8,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4906.1, 18981.74)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hz",
    x1: -195.21,
    y1: 763.07,
    x2: -195.21,
    y2: 761.8,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4930.9, 18981.74)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ia",
    x1: -194.94,
    y1: 763.07,
    x2: -194.94,
    y2: 761.8,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4954.84, 18981.74)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib",
    x1: -194.67,
    y1: 763.07,
    x2: -194.67,
    y2: 761.8,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4979.63, 18981.74)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic",
    x1: -194.39,
    y1: 763.07,
    x2: -194.39,
    y2: 761.8,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5004.43, 18981.74)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id",
    x1: -195.48,
    y1: 763.41,
    x2: -195.48,
    y2: 762.14,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4906.1, 18950.98)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ie",
    x1: -195.21,
    y1: 763.41,
    x2: -195.21,
    y2: 762.14,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4930.9, 18950.98)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "if",
    x1: -194.94,
    y1: 763.41,
    x2: -194.94,
    y2: 762.14,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4954.84, 18950.98)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig",
    x1: -194.67,
    y1: 763.41,
    x2: -194.67,
    y2: 762.14,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4979.63, 18950.98)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ih",
    x1: -194.39,
    y1: 763.41,
    x2: -194.39,
    y2: 762.14,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5004.43, 18950.98)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ii",
    x1: -195.35,
    y1: 763.58,
    x2: -195.35,
    y2: 762.31,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4918.07, 18935.61)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ij",
    x1: -195.08,
    y1: 763.58,
    x2: -195.08,
    y2: 762.31,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4942.87, 18935.61)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ik",
    x1: -194.8,
    y1: 763.58,
    x2: -194.8,
    y2: 762.31,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4967.66, 18935.61)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il",
    x1: -194.53,
    y1: 763.58,
    x2: -194.53,
    y2: 762.31,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 4992.46, 18935.61)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "im",
    x1: -194.25,
    y1: 763.58,
    x2: -194.25,
    y2: 762.31,
    gradientTransform: "matrix(24.8, 0, 0, -24.77, 5017.25, 18935.61)",
    xlinkHref: "#hd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "in",
    x: 64.64,
    y: 0,
    width: 125.73,
    height: 48.09,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.37)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "64.64 0.38 190.37 0.38 190.37 48.47 64.64 48.47 64.64 0.38",
    fill: "#fff"
  }))))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ban-khar-colored_test")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "143.96 366.11 156.45 404.05 150.22 411.1 156.47 434.4 165.68 434.4 162.41 403.5 173.78 366.09 143.96 366.11",
    fill: "url(#a)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.26 366.12 99.81 404.08 106.05 411.12 99.83 434.43 90.61 434.44 93.85 403.54 82.44 366.14 112.26 366.12",
    fill: "url(#b)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.11 213.32 39.54 199.75 126.52 199.7 127.9 199.7 214.88 199.65 246.33 213.18 254.48 257.63 207.34 297.23 199.75 286.93 215.99 248.43 226.83 248.43 214.9 240.84 210.56 228.38 205.15 252.23 181.34 315.13 179.18 329.22 179.2 368.8 128 368.83 126.62 368.83 75.41 368.86 75.39 329.28 73.21 315.19 49.33 252.32 43.89 228.47 39.56 240.94 27.64 248.54 38.48 248.53 54.77 287.01 47.18 297.32 0 257.77 8.11 213.32",
    fill: "#b72026"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.85,445.62l25.48,4.32s9.21-1.09,3.25-9.76l-17.89-5.41h-9.22Z",
    transform: "translate(0 -0.37)",
    fill: "#b72026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.22,445.65,75.74,450s-9.22-1.08-3.26-9.76l17.89-5.43h9.22Z",
    transform: "translate(0 -0.37)",
    fill: "#b72026"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.14,
    y: 191.8,
    width: 175.03,
    height: 137.55,
    fill: "none"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "173.65 202.58 74.58 207.8 73.42 275.51 111.38 318.18 158.19 315.95 183.73 268.3 173.65 202.58",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.28,265.69h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.28,265.39h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.23,265a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#e)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,273.6h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.28,273.29h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.23,273a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#f)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,281.5h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.29,281.2h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.23,280.86a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#g)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,289.41h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.29,289.1h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.24,288.76a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#h)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,297.32h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.29,297h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.24,296.67a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#i)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,305.22h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3,304.91h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.25,304.57a5.73,5.73,0,0,1-2,.34h-6V297h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#j)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,313.13h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3,312.82h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.25,312.48a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#k)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31,321h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.31,320.72h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.26,320.38a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#l)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31,328.94h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.31,328.63h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.26,328.29a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#m)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.31,269.65h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.31,269.34h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.26,269a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#n)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.31,277.55h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.31,277.25h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.26,276.91a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#o)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,285.46h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.32,285.15h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,284.81a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#p)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,293.36h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.32,293.06h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,292.72a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#q)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,301.27h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.33,301h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.28,300.62a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#r)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,309.18h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.33,308.87h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.28,308.53a5.73,5.73,0,0,1-2,.34h-6V301h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#s)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,317.08h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.34,316.77h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.28,316.43a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#t)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,325h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.34,324.68h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,324.34a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#u)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.34,265.7h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.34,265.39h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.29,265.05a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#v)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.34,273.6h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.34,273.3h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.29,273a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#w)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35,281.51h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.35,281.2h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.29,280.86a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#x)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35,289.42h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.35,289.11h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,288.77a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#y)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35,297.32h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.35,297h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,296.67a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#z)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.36,305.23h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,304.92h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.31,304.58a5.73,5.73,0,0,1-2,.34h-6V297h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#aa)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.36,313.13h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,312.83h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.31,312.48a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ab)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.37,321h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.37,320.73h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.32,320.39a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ac)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.37,328.94h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.37,328.64h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.32,328.3a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ad)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.37,269.65h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.37,269.35h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.32,269a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ae)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.37,277.56h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.37,277.25h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.32,276.91a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#af)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.38,285.46h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.38,285.16h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.33,284.82a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ag)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.38,293.37h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.38,293.06h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.33,292.72a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ah)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.39,301.28h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.39,301h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,300.63a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ai)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.39,309.18h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.39,308.87h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,308.53a5.73,5.73,0,0,1-2,.34h-6V301h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#aj)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,317.09h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4,316.78h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,316.44a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ak)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,325h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4,324.69h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,324.34a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#al)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4,265.7h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4,265.4h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.35,265.06a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#am)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4,273.61h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4,273.3h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.35,273a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#an)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41,281.52h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M68.41,281.21h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.35,280.87a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ao)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41,289.42h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M68.41,289.11h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.36,288.77a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ap)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41,297.33h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M68.41,297h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.36,296.68a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#aq)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,305.23h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.42,304.93h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.37,304.58a5.73,5.73,0,0,1-2,.34h-6V297h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ar)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,313.14h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M68.42,312.83h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.37,312.49a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#as)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,321h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68.43,320.74h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.38,320.4a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#at)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,328.95h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M68.43,328.64h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.38,328.3a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#au)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.43,269.66h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.43,269.35h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.38,269a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#av)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.43,277.56h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.43,277.26h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.38,276.92a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#aw)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.44,285.47h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.44,285.16h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,284.82a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ax)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.44,293.38h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63.44,293.07h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,292.73a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ay)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.45,301.28h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M63.45,301h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.4,300.63a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#az)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.45,309.19h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.45,308.88h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.4,308.54a5.73,5.73,0,0,1-2,.34h-6V301h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ba)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46,317.09h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M63.46,316.79h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.4,316.44a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bb)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46,325h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M63.46,324.69h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.41,324.35a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bc)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46,265.71h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M58.46,265.4h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.41,265.06a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bd)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46,273.62h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58.46,273.31h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.41,273a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#be)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47,281.52h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.46,281.21h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.41,280.87a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bf)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47,289.43h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M58.47,289.12h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,288.78a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bg)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47,297.33h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M58.47,297h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,296.68a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bh)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.48,305.24h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M58.48,304.93h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.43,304.59a5.73,5.73,0,0,1-2,.34h-6V297h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bi)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.48,313.14h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.48,312.84h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.43,312.5a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bj)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.49,321h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.49,320.74h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.44,320.4a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bk)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.49,329h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M58.49,328.65h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.44,328.31a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bl)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49,269.66h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M53.49,269.36h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,269a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bm)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49,277.57h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M53.49,277.26h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,276.92a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bn)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,285.48h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5,285.17h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.45,284.83a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bo)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,293.38h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5,293.07h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.45,292.73a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bp)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,301.29h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M53.51,301h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.46,300.64a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bq)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,309.19h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M53.51,308.89h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.46,308.54a5.73,5.73,0,0,1-2,.34h-6V301h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#br)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.52,317.1h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M53.52,316.79h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.46,316.45a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bs)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.52,325h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M53.52,324.7h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.47,324.36a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bt)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.52,265.72h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.52,265.41h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.47,265.07a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bu)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.52,273.62h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M48.52,273.31h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.47,273a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bv)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.53,281.53h6c4.45,0,6-4.26,6-4.26S59,273,54.51,273h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M48.52,281.22h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.47,280.88a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bw)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.53,289.43h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.53,289.13h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.48,288.79a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bx)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.53,297.34h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.53,297h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.48,296.69a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#by)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.54,305.24h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48.54,304.94h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,304.6a5.73,5.73,0,0,1-2,.34h-6V297h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#bz)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.54,313.15h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M48.54,312.84h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,312.5a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ca)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.55,321.05h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48.55,320.75h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,320.41a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cb)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.55,329h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.55,328.65h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,328.31a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cc)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,269.67h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M43.55,269.36h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,269a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cd)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,277.58h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M43.55,277.27h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,276.93a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ce)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.56,285.48h6c4.45,0,6-4.26,6-4.26S54,277,49.55,277h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M43.56,285.17h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.51,284.83a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cf)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.56,293.39h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M43.56,293.08h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.51,292.74a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cg)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,301.29h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.57,301h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.52,300.65a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ch)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,309.2h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M43.57,308.89h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.52,308.55a5.73,5.73,0,0,1-2,.34h-6V301h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ci)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.58,317.1h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M43.58,316.8h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.52,316.46a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cj)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.58,325h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M43.58,324.7h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.53,324.36a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ck)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.58,265.72h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M38.58,265.41h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.52,265.07a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cl)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.58,273.63h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M38.58,273.32h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.53,273a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cm)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.58,281.53h6c4.45,0,6-4.26,6-4.26S49,273,44.57,273h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M38.58,281.23h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.53,280.89a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cn)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.59,289.44h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M38.59,289.13h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.54,288.79a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#co)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.59,297.34h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38.59,297h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.54,296.7a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cp)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,305.25h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,304.94h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.55,304.6a5.73,5.73,0,0,1-2,.34h-6V297h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cq)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,313.15h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,312.85h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.55,312.51a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cr)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,321.06h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M38.61,320.75h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.56,320.41a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cs)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,329h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M38.61,328.66h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.56,328.32a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ct)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.61,269.68h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M33.61,269.37h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.56,269a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cu)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.61,277.58h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M33.61,277.27h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.56,276.93a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cv)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.62,285.49h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M33.62,285.18h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,284.84a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cw)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.62,293.39h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M33.62,293.09h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,292.75a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cx)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63,301.3h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M33.63,301h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.58,300.65a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cy)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63,309.2h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M33.63,308.9h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.58,308.56a5.73,5.73,0,0,1-2,.34h-6V301h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#cz)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.64,317.11h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M33.63,316.8h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.58,316.46a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#da)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.64,325h6c4.45,0,6-4.26,6-4.26s-1.56-4.26-6-4.26h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M33.64,324.71h6c4.13,0,5.57-4,5.57-4s-1.45-4-5.58-3.95h-6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.59,324.37a5.73,5.73,0,0,1-2,.34h-6v-7.9h6a5.73,5.73,0,0,1,2,.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#db)",
    style: {
      mixBlendMode: "multiply"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.48,320.37h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M166.49,320.68h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.54,321a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#de)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.48,312.47h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M166.48,312.78h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.53,313.12a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#df)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.48,304.56h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M166.48,304.87h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.53,305.21a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dg)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.47,296.66h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M166.47,297h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.52,297.31a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dh)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.47,288.75h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M166.47,289.06h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.52,289.4a5.73,5.73,0,0,1,2-.34h6V297h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#di)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,280.85h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M166.46,281.15h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,281.49a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dj)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,272.94h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M166.46,273.25h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,273.59a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dk)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.45,265h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M166.45,265.34h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,265.68a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dl)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.45,257.13h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M166.45,257.44h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,257.78a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dm)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.45,316.42h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M171.45,316.73h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.5,317.07a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dn)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.45,308.51h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M171.45,308.82h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.5,309.16a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#do)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,300.61h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M171.44,300.92h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,301.26a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dp)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,292.7h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M171.44,293h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,293.35a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dq)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,284.8h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M171.43,285.11h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,285.45a5.73,5.73,0,0,1,2-.34h6V293h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dr)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,276.89h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M171.43,277.2h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,277.54a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ds)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,269h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M171.43,269.29h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,269.63a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dt)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,261.08h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M171.42,261.39h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.47,261.73a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#du)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.42,320.37h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M176.43,320.68h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,321a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dv)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.42,312.46h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M176.42,312.77h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,313.11a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dw)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.42,304.56h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M176.42,304.87h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,305.21a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dx)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.41,296.65h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M176.41,297h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,297.3a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dy)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.41,288.75h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M176.41,289.05h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,289.39a5.73,5.73,0,0,1,2-.34h6V297h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#dz)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4,280.84h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M176.4,281.15h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,281.49a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ea)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4,272.94h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M176.4,273.24h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,273.58a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#eb)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.39,265h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M176.39,265.34h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.44,265.68a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ec)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.39,257.13h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M176.39,257.43h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.44,257.77a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ed)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,316.41h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M181.39,316.72h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,317.06a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ee)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,308.51h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M181.39,308.82h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,309.16a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ef)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,300.6h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M181.38,300.91h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,301.25a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#eg)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,292.7h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M181.38,293h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,293.35a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#eh)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,284.79h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M181.37,285.1h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,285.44a5.73,5.73,0,0,1,2-.34h6V293h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ei)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,276.89h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M181.37,277.19h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,277.53a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ej)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,269h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M181.37,269.29h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,269.63a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ek)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.36,261.08h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M181.36,261.38h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,261.72a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#el)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.37,320.36h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M186.37,320.67h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.42,321a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#em)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,312.46h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M186.36,312.76h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.41,313.11a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#en)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,304.55h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M186.36,304.86h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.41,305.2a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#eo)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,296.65h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M186.35,297h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,297.29a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ep)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,288.74h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M186.35,289h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,289.39a5.73,5.73,0,0,1,2-.34h6V297h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#eq)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,280.84h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M186.34,281.14h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.39,281.48a5.73,5.73,0,0,1,2-.34h6V289h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#er)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,272.93h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M186.34,273.24h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.39,273.58a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#es)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.33,265h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M186.33,265.33h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,265.67a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#et)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.33,257.12h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M186.33,257.43h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,257.77a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#eu)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.33,316.41h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M191.33,316.72h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,317.06a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ev)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.33,308.5h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M191.33,308.81h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,309.15a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ew)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.32,300.6h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M191.32,300.9h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.37,301.25a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ex)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.32,292.69h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M191.32,293h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.37,293.34a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ey)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.31,284.79h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M191.31,285.09h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.37,285.43a5.73,5.73,0,0,1,2-.34h6V293h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ez)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.31,276.88h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M191.31,277.19h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,277.53a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fa)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.31,269h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M191.31,269.28h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,269.62a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fb)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.3,261.07h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M191.3,261.38h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.35,261.72a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fc)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.31,320.36h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M196.31,320.66h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,321a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fd)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.3,312.45h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M196.3,312.76h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,313.1a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fe)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.3,304.55h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M196.3,304.85h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,305.19a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ff)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.29,296.64h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M196.29,296.95h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.34,297.29a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fg)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.29,288.74h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M196.29,289h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.34,289.38a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fh)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,280.83h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M196.28,281.14h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.33,281.48a5.73,5.73,0,0,1,2-.34h6V289h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fi)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,272.92h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M196.28,273.23h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.33,273.57a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fj)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.27,265h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M196.27,265.33h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.32,265.67a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fk)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.27,257.11h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M196.27,257.42h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.32,257.76a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fl)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.27,316.4h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M201.27,316.71h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,317.05a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fm)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.27,308.5h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M201.27,308.8h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,309.15a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fn)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,300.59h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M201.26,300.9h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,301.24a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fo)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,292.69h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M201.26,293h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,293.33a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fp)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,284.78h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M201.25,285.09h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,285.43a5.73,5.73,0,0,1,2-.34h6V293h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fq)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,276.88h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M201.25,277.18h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,277.52a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fr)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,269h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M201.25,269.28h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,269.62a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fs)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.24,261.06h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M201.24,261.37h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,261.71a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ft)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.25,320.35h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M206.25,320.66h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.3,321a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fu)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.24,312.45h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M206.24,312.75h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.29,313.09a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fv)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.24,304.54h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M206.24,304.85h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.29,305.19a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fw)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,296.64h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M206.23,296.94h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,297.28a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fx)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,288.73h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M206.23,289h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,289.38a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fy)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22,280.82h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M206.22,281.13h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,281.47a5.73,5.73,0,0,1,2-.34h6V289h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#fz)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22,272.92h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M206.22,273.23h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,273.57a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ga)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.21,265h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M206.21,265.32h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.26,265.66a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gb)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.21,257.11h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M206.21,257.42h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.26,257.76a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gc)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,316.4h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M211.21,316.7h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,317a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gd)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,308.49h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M211.21,308.8h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,309.14a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ge)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,300.59h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2,300.89h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,301.23a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gf)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,292.68h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2,293h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,293.33a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gg)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,284.78h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2,285.08h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,285.42a5.73,5.73,0,0,1,2-.34h6V293h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gh)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,276.87h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M211.19,277.18h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.24,277.52a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gi)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,269h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M211.19,269.27h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.24,269.61a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gj)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.18,261.06h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M211.18,261.37h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.23,261.71a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gk)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.19,320.35h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M216.19,320.65h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.24,321a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gl)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.18,312.44h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M216.18,312.75h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.23,313.09a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gm)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.18,304.54h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M216.18,304.84h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.23,305.18a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gn)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,296.63h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M216.17,296.94h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.22,297.28a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#go)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,288.72h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M216.17,289h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.22,289.37a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gp)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,280.82h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M216.16,281.13h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.21,281.47a5.73,5.73,0,0,1,2-.34h6V289h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gq)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,272.91h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M216.16,273.22h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.21,273.56a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gr)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.15,265h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M216.15,265.31h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.2,265.66a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gs)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.15,257.1h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M216.15,257.41h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.2,257.75a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gt)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,316.39h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M221.15,316.7h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,317a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gu)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,308.49h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M221.15,308.79h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,309.13a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gv)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,300.58h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M221.14,300.89h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,301.23a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gw)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,292.68h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M221.14,293h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.19,293.32a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gx)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,284.77h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M221.14,285.08h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.19,285.42a5.73,5.73,0,0,1,2-.34h6V293h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gy)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.13,276.86h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M221.13,277.17h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,277.51a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#gz)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.13,269h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M221.13,269.27h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,269.61a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ha)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.12,261.05h-6c-4.45,0-6,4.26-6,4.26s1.56,4.26,6,4.26h6Z",
    transform: "translate(0 -0.37)",
    fill: "#221f1f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M221.12,261.36h-6c-4.13,0-5.57,4-5.57,4s1.45,4,5.58,3.95h6Z",
    transform: "translate(0 -0.37)",
    fill: "#4e4d50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,261.7a5.73,5.73,0,0,1,2-.34h6v7.9h-6a5.73,5.73,0,0,1-2-.33Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hb)",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M91.73,205.58l71.51,0c23.18,64.9-35.69,109.16-35.69,109.16C114.16,301.37,70.79,266.69,91.73,205.58Z",
    transform: "translate(0 -0.37)",
    fill: "#fff"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M139.9,209.29l.57-1.32a21.86,21.86,0,0,0-2.71-2.42h-2.68Z",
    transform: "translate(0 -0.37)",
    fill: "#595352"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.16 287.35 125.27 295.05 122.3 289.49 142.86 273.5 135.16 287.35",
    fill: "#6b6562"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.02 300.21 126.3 296.99 132.49 292.16 128.02 300.21",
    fill: "#6b6562"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.27 267.37 145.54 268.69 121.27 287.56 118.4 282.18 144.51 261.88 146.27 267.37",
    fill: "#6b6562"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.57 205.18 139.01 210.96 139.9 208.92 135.09 205.18 131.57 205.18",
    fill: "#fff5d4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M110.94,264.86l3-9.93,1.06-3.56,2.49-8.36h0l.07-.24.4-1.36,1.06-3.56,0,0,3.71-12.25v0l-4.09-9-1.91-4.21L115,208.51a18.32,18.32,0,0,1,2.92-2.95h13.67l7.45,5.78-2.52,5.82-.89,2L133.08,225l-.26.59.76,2.54.34,1.15,1.88,5.86.7,2.19,2,6.1.7,2.19,2,6.18.7,2.18,1.95,6.07-26.43,20.55-2.86-5.36-1-1.93-2.91-5.46-.34-.64Z",
    transform: "translate(0 -0.37)",
    fill: "#d0262a"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.51 261.88 118.4 282.18 117.37 280.25 143.81 259.69 144.51 261.88",
    fill: "#fff5d4"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.86 273.5 122.3 289.49 121.27 287.56 145.54 268.69 142.86 273.5",
    fill: "#fff5d4"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.49 292.16 126.3 296.99 125.27 295.05 135.16 287.35 132.49 292.16",
    fill: "#fff5d4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M167.51,200.39s6.57,15.81,6.57,15.81L130.63,318.49l-5.75-.6c-.11-8.05-.36-47.64-.36-47.64C148,265.31,167.51,200.39,167.51,200.39Z",
    transform: "translate(0 -0.37)",
    fill: "#c2bdbb"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M89.16,200.43s-8.61,11-8.61,11l45.87,106.49,5.52.51c.1-8.05.3-46.14.3-46.14C106,262.38,89.16,200.43,89.16,200.43Z",
    transform: "translate(0 -0.37)",
    fill: "#a8a4a3"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "80.55 204.09 115.19 200.04 127.21 205.47 139.23 200.03 173.87 204.03 158.74 234.18 127.21 206.15 95.72 234.21 80.55 204.09",
    fill: "#c4caca",
    style: {
      mixBlendMode: "multiply"
    }
  }), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.55 201.78 115.19 200.04 127.21 205.07 139.23 200.03 173.87 201.72 158.74 231.87 127.21 205.47 95.72 231.91 80.55 201.78",
    fill: "#fff"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M128.28,318.3s37.74-87.11,31.1-117.91h18.28s5.25,9,5.94,15.17c0,0-8.85,8.81-10.69,8.24L189,231.36C176,272,128,319.61,130.11,322.61A10.88,10.88,0,0,1,128.28,318.3Z",
    transform: "translate(0 -0.37)",
    fill: "#d0262a"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M129,318.3S91.2,231.23,97.81,200.43H79.54s-5.24,9-5.92,15.17c0,0,8.85,8.8,10.7,8.23l-16.06,7.59c1.38,17.22,46.38,76.05,57.94,88.54,1.17,1.27,3.8,3.77,5.84,4.36C132,324.33,130.44,321.22,129,318.3Z",
    transform: "translate(0 -0.37)",
    fill: "#d0262a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.47,
    cy: 275.82,
    rx: 2.84,
    ry: 2.71,
    fill: "#767472"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.48,
    cy: 295.72,
    rx: 2.84,
    ry: 2.72,
    fill: "#767472"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M62.72,110.33",
    transform: "translate(0 -0.37)",
    fill: "#414141"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.42,
    cy: 332.76,
    rx: 3.97,
    ry: 3.95,
    fill: "#4e4f50"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.42,
    cy: 346.08,
    rx: 3.97,
    ry: 3.95,
    fill: "#4e4f50"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M204.48,81.21c.06-1.19.09-2.39.09-3.59,0-42.75-35.64-73.76-76.32-73.76S52.06,34,52.06,76.8c0,1.49.05,3,.14,4.46h-.14l.26,1.52a80.73,80.73,0,0,0,2.41,14.29L66,164c2.24,13.27,10.33,23.29,21.14,32.28a79.65,79.65,0,0,0,18.06,11.61,88,88,0,0,0,10.13,3.78h0a28.29,28.29,0,0,0,2.81.74c.94.22,1.85.39,2.71.5a51.29,51.29,0,0,0,15,.08,31.34,31.34,0,0,0,5.24-1,48.86,48.86,0,0,0,6.82-2.28h0c1.89-.73,3.44-1.39,4.29-1.78a79.7,79.7,0,0,0,18.06-11.61c10.81-9,18.91-19,21.14-32.28,4.65-27.59,8.42-55.24,13.07-82.84h0",
    transform: "translate(0 -0.37)",
    fill: "#262322"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.11,176.51v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M90,176.51v23.68c0,16.35-15.81,22.07-15.81,22.07S58.4,216.52,58.4,200.18V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,176.51v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M132.37,176.51v23.68c0,16.35-21.17,22.07-21.17,22.07S90,216.52,90,200.18V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.34,176.51v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M157.55,176.51v23.68c0,16.35-18,22.07-18,22.07s-18-5.74-18-22.07V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186,176.51v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M184.87,176.51v23.68c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,176.51v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M216.48,176.51v23.68c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V176.51Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,208.1a22.6,22.6,0,0,0,1.34-7.85V176.51H184.87v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hd)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,155.81v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V155.81Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M74.76,156.9v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V156.9Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,188.47a22.61,22.61,0,0,0,1.34-7.85V156.9H43.14v23.74a22.61,22.61,0,0,0,1.34,7.85H73.41Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#he)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,155.81v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V155.81Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M106.37,156.9v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V156.9Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105,188.47a22.62,22.62,0,0,0,1.34-7.85V156.9H74.76v23.74a22.61,22.61,0,0,0,1.34,7.85H105Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hf)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,155.81v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V155.81Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M136.9,156.9v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V156.9Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,188.47a22.61,22.61,0,0,0,1.34-7.85V156.9H105.28v23.74a22.61,22.61,0,0,0,1.34,7.85h28.92Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hg)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,155.81v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V155.81Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M168.51,156.9v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V156.9Z",
    transform: "translate(0 -0.37)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,188.47a22.61,22.61,0,0,0,1.34-7.85V156.9H136.9v23.74a22.61,22.61,0,0,0,1.34,7.85h28.92Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hh)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,155.81v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V155.81Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M200.13,156.9v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V156.9Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.78,188.47a22.61,22.61,0,0,0,1.34-7.85V156.9H168.51v23.74a22.61,22.61,0,0,0,1.34,7.85h28.92Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hi)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.11,136.21v23.95c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V136.22h33.8Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M90,136.21v23.67C90,176.23,74.21,182,74.21,182S58.4,176.22,58.4,159.88V136.21Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.67,167.8A22.62,22.62,0,0,0,90,159.95V136.21H58.4v23.74a22.61,22.61,0,0,0,1.34,7.85H88.67Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hj)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,136.21v23.95c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V136.22h33.8Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M121.63,136.21v23.67c0,16.35-15.81,22.07-15.81,22.07S90,176.22,90,159.88V136.21Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,167.8a22.62,22.62,0,0,0,1.34-7.85V136.21H90v23.74a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hk)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.34,136.21v23.95c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V136.22h33.8Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M153.25,136.21v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V136.21Z",
    transform: "translate(0 -0.37)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,167.8a22.61,22.61,0,0,0,1.34-7.85V136.21H121.64v23.74A22.61,22.61,0,0,0,123,167.8h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hl)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,136.21v23.95c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V136.22H186Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M184.87,136.21v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V136.21Z",
    transform: "translate(0 -0.37)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,167.8a22.61,22.61,0,0,0,1.34-7.85V136.21H153.25v23.74a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hm)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,136.21v23.95c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V136.22h33.8Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M216.48,136.21v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V136.21Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,167.8a22.61,22.61,0,0,0,1.34-7.85V136.21H184.87v23.74a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hn)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,116.6v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M74.76,116.6v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,148.19a22.61,22.61,0,0,0,1.34-7.85V116.6H43.14v23.74a22.61,22.61,0,0,0,1.34,7.85H73.41Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ho)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,116.6v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M106.37,116.6v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105,148.19a22.62,22.62,0,0,0,1.34-7.85V116.6H74.76v23.74a22.61,22.61,0,0,0,1.34,7.85Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hp)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,116.6v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M136.9,116.6v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,148.19a22.61,22.61,0,0,0,1.34-7.85V116.6H105.28v23.74a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hq)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,116.6v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M168.51,116.6v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,148.19a22.61,22.61,0,0,0,1.34-7.85V116.6H136.9v23.74a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hr)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,116.6v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M200.13,116.6v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V116.6Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.78,148.19a22.61,22.61,0,0,0,1.34-7.85V116.6H168.51v23.74a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hs)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.11,97v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V97Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M90,97v23.67c0,16.35-15.81,22.07-15.81,22.07S58.4,137,58.4,120.67V97Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.67,128.58A22.61,22.61,0,0,0,90,120.73V97H58.4v23.74a22.6,22.6,0,0,0,1.34,7.85H88.67Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ht)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,97v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V97Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M121.63,97v23.67c0,16.35-15.81,22.07-15.81,22.07S90,137,90,120.67V97Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,128.58a22.61,22.61,0,0,0,1.34-7.85V97H90v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hu)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.34,97v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V97Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M153.25,97v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V97Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,128.58a22.6,22.6,0,0,0,1.34-7.85V97H121.64v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hv)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,97v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V97Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M184.87,97v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V97Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,128.58a22.6,22.6,0,0,0,1.34-7.85V97H153.25v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hw)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,97v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V97Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M216.48,97v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V97Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,128.58a22.6,22.6,0,0,0,1.34-7.85V97H184.87v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hx)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,77.39v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M74.76,77.39v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,109a22.6,22.6,0,0,0,1.34-7.85V77.39H43.14v23.74A22.6,22.6,0,0,0,44.48,109H73.41Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hy)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,77.39v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M106.37,77.39v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105,109a22.62,22.62,0,0,0,1.34-7.85V77.39H74.76v23.74A22.6,22.6,0,0,0,76.1,109Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#hz)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,77.39v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M136.9,77.39v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,109a22.6,22.6,0,0,0,1.34-7.85V77.39H105.28v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ia)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,77.39v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M168.51,77.39v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,109a22.6,22.6,0,0,0,1.34-7.85V77.39H136.9v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ib)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,77.39v23.94c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M200.13,77.39v23.67c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V77.39Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.78,109a22.6,22.6,0,0,0,1.34-7.85V77.39H168.51v23.74a22.6,22.6,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ic)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.11,57.78V81.72c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V57.78Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M90,57.78V81.46c0,16.34-15.81,22.07-15.81,22.07S58.4,97.79,58.4,81.46V57.8H90Z",
    transform: "translate(0 -0.37)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,57.78V81.72c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V57.78Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M121.63,57.78V81.46c0,16.34-15.81,22.07-15.81,22.07S90,97.79,90,81.46V57.8h31.62Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.34,57.78V81.72c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V57.78Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M153.25,57.78V81.46c0,16.34-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V57.8h31.62Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186,57.78V81.72c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V57.78Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M184.87,57.78V81.46c0,16.34-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V57.8h31.62Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,57.78V81.72c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V57.78Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M216.48,57.78V81.46c0,16.34-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V57.8h31.62Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,38.18V62.11c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M74.76,38.18V61.85c0,16.35-15.81,22.07-15.81,22.07S43.14,78.18,43.14,61.85V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,69.76a22.61,22.61,0,0,0,1.34-7.85V38.18H43.14V61.92a22.61,22.61,0,0,0,1.34,7.85H73.41Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#id)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,38.18V62.11c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M106.37,38.18V61.85c0,16.35-15.81,22.07-15.81,22.07S74.76,78.18,74.76,61.85V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105,69.76a22.62,22.62,0,0,0,1.34-7.85V38.18H74.76V61.92a22.61,22.61,0,0,0,1.34,7.85Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ie)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,38.18V62.11c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M136.9,38.18V61.85c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,69.76a22.61,22.61,0,0,0,1.34-7.85V38.18H105.28V61.92a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#if)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,38.18V62.11c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M168.51,38.18V61.85c0,16.35-15.81,22.07-15.81,22.07S136.9,78.18,136.9,61.85V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,69.76a22.61,22.61,0,0,0,1.34-7.85V38.18H136.9V61.92a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ig)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,38.18V62.11c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M200.13,38.18V61.85c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V38.18Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.78,69.76a22.61,22.61,0,0,0,1.34-7.85V38.18H168.51V61.92a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ih)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.11,18.57V42.51c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M90,18.57V42.24c0,16.35-15.81,22.07-15.81,22.07S58.4,58.58,58.4,42.24V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.67,50.16A22.62,22.62,0,0,0,90,42.31V18.57H58.4V42.31a22.61,22.61,0,0,0,1.34,7.85H88.67Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ii)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,18.57V42.51c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M121.63,18.57V42.24c0,16.35-15.81,22.07-15.81,22.07S90,58.58,90,42.24V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,50.16a22.62,22.62,0,0,0,1.34-7.85V18.57H90V42.31a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ij)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.34,18.57V42.51c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M153.25,18.57V42.24c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,50.16a22.61,22.61,0,0,0,1.34-7.85V18.57H121.64V42.31A22.61,22.61,0,0,0,123,50.16h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#ik)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,18.57V42.51c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M184.87,18.57V42.24c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,50.16a22.61,22.61,0,0,0,1.34-7.85V18.57H153.25V42.31a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#il)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,18.57V42.51c0,17.77-16.9,24-16.9,24s-16.9-6.22-16.9-24V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M216.48,18.57V42.24c0,16.35-15.81,22.07-15.81,22.07s-15.81-5.74-15.81-22.07V18.57Z",
    transform: "translate(0 -0.37)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,50.16a22.61,22.61,0,0,0,1.34-7.85V18.57H184.87V42.31a22.61,22.61,0,0,0,1.34,7.85h28.93Z",
    transform: "translate(0 -0.37)",
    opacity: 0.4,
    fill: "url(#im)",
    style: {
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#in)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,5.58l-.12,0c-12.3,4.58-25.3,11.95-37.25,1.84,0,0,1.14,42.65,46.83,41a120.39,120.39,0,0,0,15.71-2.22A72.18,72.18,0,0,0,139,42.94c3.61-1.41,6.55-4.41,10.19-5.54a13.61,13.61,0,0,1,3.9-.45c13.89-.13,22.24-4.57,37.32-2.54.19,0-5.19-6.05-5.38-6.4a55.58,55.58,0,0,0-10.72-14.48C157.19-2.79,122.56-2,102,5.58",
    transform: "translate(0 -0.37)",
    fill: "#262322"
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M78.56,38.14S54.74,58.59,53.09,64.35c0,0,2.07-18.69,17.72-36Z",
    transform: "translate(0 -0.37)",
    fill: "#262322"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.73,
    cy: 109.29,
    rx: 30.73,
    ry: 28.16,
    transform: "translate(-16.61 14.47) rotate(-9.32)",
    fill: "#4a4a4c"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M84.58,127.84c10.09-1.66,17.07-10.53,15.55-19.78s-11-15.43-21.06-13.77S62,104.83,63.52,114.08,74.49,129.5,84.58,127.84Z",
    transform: "translate(0 -0.37)",
    fill: "#fff"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M54.69,98.6s22.72-5.6,57.56,17.58c0,0,9.8-30.59-24-35.89C88.29,80.29,66.87,75.56,54.69,98.6Z",
    transform: "translate(0 -0.37)",
    fill: "#957950"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M111.48,118.38s-40.25,19.45-58.17-16.32c0,0-10.79,29.5,23.89,36.37C77.2,138.44,103,141.3,111.48,118.38Z",
    transform: "translate(0 -0.37)",
    fill: "#957950"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.61,
    cy: 109.29,
    rx: 28.16,
    ry: 30.73,
    transform: "translate(40.15 265.49) rotate(-80.68)",
    fill: "#4a4a4c"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M174.76,127.84c-10.09-1.66-17.07-10.53-15.55-19.78s11-15.43,21.06-13.77,17.07,10.53,15.55,19.78S184.85,129.5,174.76,127.84Z",
    transform: "translate(0 -0.37)",
    fill: "#fff"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M204.66,98.6s-22.72-5.6-57.56,17.58c0,0-9.8-30.59,24-35.89C171.06,80.29,192.47,75.56,204.66,98.6Z",
    transform: "translate(0 -0.37)",
    fill: "#957950"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M147.86,118.38s40.25,19.45,58.17-16.32c0,0,10.79,29.5-23.89,36.37C182.14,138.44,156.3,141.3,147.86,118.38Z",
    transform: "translate(0 -0.37)",
    fill: "#957950"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBanKharColored, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ban-khar-colored.4115ec3b.svg";
export { ForwardRef as ReactComponent };